<template>
  <div class="space-between-y">
    <input-item label="组名称">
      <el-input v-model="form.name" type="text" placeholder="请输入标签组名称"></el-input>
    </input-item>
    <div class="space-between-x container-left">
      <input-item label="是否必选">
        <el-switch v-model="form.required"></el-switch>
      </input-item>
      <input-item label="是否可多选">
        <el-switch v-model="form.multiple"></el-switch>
      </input-item>
      <input-item label="是否作为主过滤器组件">
        <el-switch v-model="form.main"></el-switch>
      </input-item>
    </div>

    <input-item label="使用场景">
      <el-select v-model="form.useFor" placeholder="请选择">
        <el-option disabled label="家长需求标签" value="demand"></el-option>
        <el-option label="教师服务标签" value="product"></el-option>
      </el-select>
    </input-item>

    <el-button @click="save" type="primary">保存</el-button>

  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import {miuTag} from "@/api/miu/tag";
import {msg} from "@/assets/js/my-vue-element-ui-js";

export default {
  name: 'MiuTagGroup',
  components: {InputItem},
  props: {
    id: Number
  },

  data() {
    return {
      form: {
        name: "",
        useFor: "",
        required: false,
        // 是否多选
        multiple: false,
        main: false
      },
    }
  },

  created() {
    if (this.id !== null) {
      miuTag.groupInfo(this.id).then(res => {
        this.form = res.data;
      })
    }
  },

  methods: {
    save() {
      miuTag.save(this.id, this.form.name, this.form.useFor, this.form.required, this.form.multiple, this.form.main).then(res => {
        msg(res, this);
        if (res.code === 200) {
          this.$emit("saved");
        }
      })
    },
  },


};
</script>

<style scoped>
</style>
